import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["referralLink", "copyButton"]
  static values = {
    shareText: String,
    copyLabel: String,
    copiedLabel: String
  }

  copy() {
    navigator.clipboard?.writeText(this.referralLinkTarget.value)
    if (!this.hasCopyButtonTarget) return

    this.copyButtonTarget.textContent = this.copiedLabelValue
    clearTimeout(this.copyResetTimer)
    this.copyResetTimer = setTimeout(() => {
      this.copyButtonTarget.textContent = this.copyLabelValue
    }, 2000)
  }

  share() {
    if (!navigator.share) return

    navigator.share({
      title: "VoiceClone",
      text: this.shareTextValue,
      url: this.referralLinkTarget.value
    }).catch(() => {})
  }
}
